function Privacy() {
  return (
    <div className="max-w-5xl mx-auto py-20 px-6">

      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

      <p className="text-gray-600 mb-4">
        We respect your privacy and protect your personal data.
      </p>

      <p className="text-gray-600 mb-4">
        Your information is only used for order processing and customer
        support.
      </p>

      <p className="text-gray-600">
        We never share your personal information with third parties.
      </p>

    </div>
  );
}

export default Privacy;
